



























import { Component, Mixins } from "vue-property-decorator";
import {
  PatientSpecifiedHeaderPane,
  NavigationPane,
} from "../panes";
import { PatientFindDialogController } from "../patient/dialogs";
import { DocumentListViewMixin } from "./mixins";
import { DocumentListViewer } from "./viewers";
import { SpecifiedPatientViewMixin } from "../patient/mixins";
import { Patient } from "../../domain/patient";
import { PatientExternalMenu } from "./viewers/menus";
import { DuplicatedPatientIndicator } from "../patient";
import { IExternalMenuItemConfiguration } from "../../domain/configuration";

@Component({
  components: {
    PatientSpecifiedHeaderPane,
    NavigationPane,
    PatientFindDialogController,
    DocumentListViewer,
    PatientExternalMenu,
    DuplicatedPatientIndicator,
  },
})
export default class PatientDocumentListView extends Mixins(SpecifiedPatientViewMixin, DocumentListViewMixin) {
  patient: Patient;

  get createDocumentDescription(): string {
    return "文書" + this.$wording.format.name + "を選択して新規文書を作成します。";
  }

  get isReady(): boolean {
    return !!this.patient && !!this.patient.id;
  }

  onDuplicatedPatientSelected(patient: Patient): void {
    const viewer = this.$refs.viewer as DocumentListViewer;
    if (!!viewer && viewer.isDocumentsFinding) {
      // TODO: そもそも検索中はボタンをdisableにしたい
      this.$error("検索中チェック", "検索処理中のため、重複ID患者の情報を反映できませんでした。");
      return;
    }
    this.patient = patient;
    // このタイミングではPatientがDocumentsFinderに反映されていないことがあるため
    this.$nextTick(() => {
      this.searchDocument();
    });
  }

  searchDocument(): void {
    (this.$refs.viewer as DocumentListViewer).find();
  }

  editNewDocument(): void {
    // 別Windowで開く.(完全SPAにするとメモリリーク発生による問題が顕在化しやすくなる恐れがあるため.)
    this.$openWindow(
      "/EditNewDocument",
      {
        patientNo: this.patient.id,
      }
    );
  }

  get isCreateButtonVisible(): boolean {
    return this.$configuration.behavior.document.list.menu.create.isEnable;
  }

  get externalMenuItems(): IExternalMenuItemConfiguration[] {
    return this.$configuration.behavior.document.list.menu.patientExternalMenus;
  }
}
